// src/hooks/useRootRef.ts
import { useRef as useReactRef } from "react";
var useRootRef = function useRootRef(ref) {
  var localRef = useReactRef();
  return ref || localRef;
};
export { useRootRef };